import { render, staticRenderFns } from "./HGAndFarmerIcon.vue?vue&type=template&id=efea0e06&scoped=true"
import script from "./HGAndFarmerIcon.vue?vue&type=script&lang=js"
export * from "./HGAndFarmerIcon.vue?vue&type=script&lang=js"
import style0 from "./HGAndFarmerIcon.vue?vue&type=style&index=0&id=efea0e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efea0e06",
  null
  
)

export default component.exports